import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import _inflection from 'lodash-inflection';
import { Button, Container, Divider, Grid, Label, Pagination, Segment } from 'semantic-ui-react';

import { Document } from '../Document';

import styles from './styles';

_.mixin(_inflection);

class DocumentList extends Component {
  state = {
    selectedDocument: null,
  };

  handleResultSelect = (result) => {
    this.setState(prevState => ({
      selectedDocument: prevState.selectedDocument ? null : result,
    }));
  };

  render() {
    const {
      documents,
      showPagination,
      activePage,
      totalPages,
      onPageChange,
      totalResults,
    } = this.props;
    return (
      <Container>
        {totalResults && (
          <Label color="blue" style={{ marginBottom: 20 }}>
            <b>{totalResults}</b> {_.pluralize('resultado', totalResults)}
          </Label>
        )}
        {documents.map((item) => {
          const isSelected = this.state.selectedDocument === item;
          return (
            <div style={{ marginBottom: 20 }} key={item._id}>
              <Segment clearing attached="top">
                <Grid stackable columns={2}>
                  <Grid.Row>
                    <Grid.Column>
                      <h4>{item.title}</h4>
                    </Grid.Column>
                    <Grid.Column>
                      <Button
                        basic={!isSelected}
                        secondary={isSelected}
                        floated="right"
                        content={isSelected ? 'Ocultar' : 'Ver'}
                        onClick={() => this.handleResultSelect(item)}
                        size="mini"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment attached="bottom">
                <p>{item.description}</p>
                {this.state.selectedDocument &&
                  isSelected && (
                    <div>
                      <Divider style={{ margin: '40px 0' }} />
                      <Document content={this.state.selectedDocument} />
                    </div>
                  )}
              </Segment>
            </div>
          );
        })}
        {showPagination && (
          <div style={styles.paginationContainer}>
            <Pagination
              onPageChange={onPageChange}
              defaultActivePage={activePage}
              totalPages={totalPages}
            />
          </div>
        )}
      </Container>
    );
  }
}

DocumentList.propTypes = {
  documents: PropTypes.array,
  showPagination: PropTypes.bool,
  activePage: PropTypes.number,
  totalPages: PropTypes.number,
  totalResults: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default DocumentList;



// WEBPACK FOOTER //
// ./src/components/DocumentList/DocumentList.js